<template>
  <CustomDialog
    v-model="dialog"
    ref="customDialog"
    :title="item?.name || 'Prêmios disponíveis'"
    subtitle="Esta item contém uma das seguintes premiações:"
    width="500"
    hideFooter
    @cancel="close()"
  >
    <div v-if="dialog">
      <loader v-if="loading" />

      <section v-else-if="draw?.items.length">
        <v-list
          class="overflow-y-auto transparent pa-0"
          max-height="25rem"
          dense
        >
          <v-list-item v-for="(item, i) in draw?.items" class="px-0" :key="i">
            <v-list-item-avatar
              class="neutral4 rarity-avatar"
              rounded
              size="32px"
              :style="{ 'border-color': `${item.color} !important` }"
            >
              <v-img
                v-if="item.image"
                :src="item.image?.objectURL || item.image"
              />

              <v-img
                v-else
                :src="
                  item.type === 'event'
                    ? require(`@/assets/prizes/${item.event}.png`)
                    : require(`@/assets/prizes/${item.type}.png`)
                "
              />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="text-body-1">
                {{ item.name }}
              </v-list-item-title>

              <v-list-item-subtitle
                class="text-body-2"
                :style="{ color: item.color }"
              >
                {{ handleRarityLabel(item.rarity) }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div class="text-center text-caption neutral6--text">
          Deslize para ver mais
        </div>
      </section>
    </div>
  </CustomDialog>
</template>

<script>
import { getItemDraw } from "@/services/draws";
import { handleRarityLabel } from "@/helpers";
import CustomDialog from "@/components/customDialog/CustomDialog";

export default {
  name: "DrawRarityDialog",

  components: {
    CustomDialog,
  },

  data() {
    return {
      loading: true,
      dialog: false,
      item: null,
      draw: null,
    };
  },

  methods: {
    async getItemDraw(itemID) {
      try {
        this.loading = true;

        const { data } = await getItemDraw(itemID);

        this.draw = data;
      } catch (error) {
        this.$alert(error?.message, "error");
      } finally {
        this.loading = false;
      }
    },

    open(data) {
      if (!this.draw) this.getItemDraw(data._id);
      if (!this.item) this.item = data;

      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    handleRarityLabel,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
